/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  // Calculer le prix après un changement de quantité
  document.querySelectorAll('.quantity__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(() => {
        const qty = parseInt(document.querySelector('.quantity__input').value) || 1;

        const selectors = [
          '.product__submit__add .product__price--regular',
          '.product__submit__add .product__price--compare',
          '.product__block .product__price .product__price--regular',
          '.product__block .product__price .product__price--compare',
          'cart-bar .cart-bar__product__price span[data-product-price]'
        ];

        selectors.forEach(sel => {
          const el = document.querySelector(sel);
          if (!el) return;
          if (!el.dataset.unitPrice) {
            el.dataset.unitPrice = parseFloat(el.textContent.replace(/[^\d,]/g, '').replace(',', '.'));
          }
          const total = (parseFloat(el.dataset.unitPrice) * qty).toFixed(2).replace('.', ',');
          el.textContent = total + ' €';
        });
      }, 50);
    });
  });


  // DIAG
  // Calcul et affichage du prix total dans .btn--routine-all
  function setRoutineTotal() {
    let total = 0;

    document.querySelectorAll('.diag-collection .routine-product:not([disabled]) .routine-product__price').forEach((el) => {
      const match = el.textContent.match(/(\d+)[,.](\d{2})/);
      if (match) total += parseFloat(`${match[1]}.${match[2]}`);
    });

    const totalEl = document.querySelector('.btn--routine-all .total-price');
    if (totalEl) totalEl.textContent = total.toFixed(2).replace('.', ',') + ' €';
  }

  setRoutineTotal();

  // Ajout individuel
  document.querySelectorAll('.btn--routine:not([disabled])').forEach((btn) => {
    btn.addEventListener('click', async function () {
      const variantId = this.getAttribute('selected-variant-id');
      if (!variantId) return;

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] }),
        });

        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
      } catch (err) {
        console.error('Erreur ajout panier :', err);
      }
    });
  });

  // Ajout de toute la routine d'un coup
  document.querySelector('.diag-collection .btn--routine-all')?.addEventListener('click', async function () {
    const items = [];

    document.querySelectorAll('.diag-collection .btn--routine[selected-variant-id]:not([disabled])').forEach((btn) => {
      const variantId = btn.getAttribute('selected-variant-id');
      if (variantId) items.push({ id: parseInt(variantId), quantity: 1 });
    });

    if (!items.length) return;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
    } catch (err) {
      console.error('Erreur ajout panier :', err);
    }
  });

})();
